<script>
  import { selectedStations, selectionActions } from "../../services/station-service.ts";

  export let station;
  export let isHover = false;
  export let isViewing = false;

  function formatDateRange(beginDate, endDate) {
    const formatDate = (dateStr) => {
      if (!dateStr || dateStr === "Present" || dateStr === "Unknown") {
        return dateStr;
      }
      
      try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime()) || date.getFullYear() < 1800) {
          return "Unknown";
        }
        
        return date.toLocaleDateString("en-US", { 
          year: "numeric", 
          month: "short" 
        });
      } catch (e) {
        return "Unknown";
      }
    };
    
    return `${formatDate(beginDate)} - ${formatDate(endDate)}`;
  }

  $: isSelected = $selectedStations.includes(station.id);

  function handleToggleSelection() {
    selectionActions.toggle(station.id);
  }
</script>

{#if isHover}
  <div class="hover-popup-content">
    <h5>{station.name}</h5>
    <small class="text-muted">Click to view details</small>
  </div>
{:else}
  <div class="station-popup">
    <h4>{station.name}</h4>
    <p><strong>ID:</strong> {station.id}</p>
    <p><strong>Date Range:</strong> {formatDateRange(station.beginDate, station.endDate)}</p>
    <p>
      <strong>Coordinates:</strong>
      {station.latitude.toFixed(4)}, {station.longitude.toFixed(4)}
    </p>

    <div class="popup-actions">
      <button
        class="btn btn-sm {isSelected ? 'btn-success' : 'btn-outline-success'}"
        on:click={handleToggleSelection}
      >
        {#if isSelected}
          <i class="bi bi-check2"></i> Selected
        {:else}
          <i class="bi bi-plus"></i> Add to List
        {/if}
      </button>
      <a
        href="station-detail?stations={station.id}"
        class="btn btn-sm btn-outline-primary detail-link"
        title="View station detail page"
        aria-label="View details for {station.name}"
      >
        <i class="bi bi-arrow-right-circle"></i> View Details
      </a>
    </div>
  </div>
{/if}

<style>
  .hover-popup-content {
    padding: 8px 12px;
    min-width: 160px;
  }

  .hover-popup-content h5 {
    margin: 0 0 4px 0;
    font-size: 0.9rem;
    color: #007ec6;
  }

  .station-popup {
    max-width: 300px;
  }

  .station-popup h4 {
    margin-bottom: 8px;
    color: #007ec6;
    font-size: 16px;
  }

  .station-popup p {
    margin-bottom: 5px;
    font-size: 0.9rem;
  }

  .popup-actions {
    margin-top: 12px;
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  :global(.btn-success),
  :global(.btn-outline-success) {
    --bs-btn-focus-shadow-rgb: 201, 82, 15;
  }
  :global(.btn-success) {
    background-color: #c9520f;
    border-color: #c9520f;
    color: #fff;
  }
  :global(.btn-success:hover),
  :global(.btn-success:focus),
  :global(.btn-success:active) {
    background-color: #a8430c;
    border-color: #a8430c;
    color: #fff;
    box-shadow: 0 0 0 0.25rem rgba(201, 82, 15, 0.4);
  }
  :global(.btn-outline-success) {
    color: #c9520f;
    border-color: #c9520f;
  }
  :global(.btn-outline-success:hover),
  :global(.btn-outline-success:focus),
  :global(.btn-outline-success:active) {
    background-color: #c9520f;
    border-color: #c9520f;
    color: #fff;
    box-shadow: 0 0 0 0.25rem rgba(201, 82, 15, 0.4);
  }
</style>
